module.exports = __webpack_public_path__ + "img/app3.f49340f7.jpg";